/**
 * @internal
 */ function getClientArgs(queryKey, opts, pageParam) {
    const path = queryKey[0];
    const input = queryKey[1]?.input;
    if (pageParam) input.cursor = pageParam;
    return [
        path.join('.'),
        input,
        opts?.trpc
    ];
}

export { getClientArgs };
